// extracted by mini-css-extract-plugin
export default {"ellipse":"TransportOriginAndDestination_ellipse__UsJVz"};